var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.332,
    height: 51.981,
    viewBox: "0 0 62.332 51.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "easy-booking",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101395",
    "data-name": "Path 101395",
    d: "M-9028.717-3111.32s-6.234-6.409-1.361-12.995c-.044-.044,8.561-11.239,8.561-11.239s5.006-8.122,13.654-2.151c-.044.044,9.087,5.356,8.385,15.453-.045,0-.309,5.532-9.746,10.932s-14.869,3.265-14.869,3.265-3.177-1.1-4.423-2.975C-9028.528-3111.03-9028.717-3111.32-9028.717-3111.32Z",
    transform: "translate(9061.772 3149.759)",
    fill: "#e7f4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plane",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41278",
    "data-name": "Group 41278",
    transform: "translate(14.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122927",
    "data-name": "Path 122927",
    d: "M141.369,9.031l-2.7-2.7L142.5,2.508a.981.981,0,0,1,1.387,0L145.2,3.817a.981.981,0,0,1,0,1.387Z",
    transform: "translate(-138.673 -2.221)",
    fill: "#3d6687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122928",
    "data-name": "Path 122928",
    d: "M211.367,42.041l-2.7-2.7,3.826-3.826a.981.981,0,0,1,1.387,0l1.309,1.309a.981.981,0,0,1,0,1.387Z",
    transform: "translate(-201.502 -31.85)",
    fill: "#3d6687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122929",
    "data-name": "Path 122929",
    d: "M445.507,313.168l2.7,2.7,3.826-3.826a.981.981,0,0,0,0-1.387l-1.31-1.31a.981.981,0,0,0-1.387,0Z",
    transform: "translate(-414.083 -277.631)",
    fill: "#3d6687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122930",
    "data-name": "Path 122930",
    d: "M408.054,243.171l2.7,2.7,3.827-3.826a.981.981,0,0,0,0-1.387l-1.309-1.309a.981.981,0,0,0-1.387,0Z",
    transform: "translate(-380.466 -214.802)",
    fill: "#3d6687"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41279",
    "data-name": "Group 41279",
    transform: "translate(0 0.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122931",
    "data-name": "Path 122931",
    d: "M86.622,56.075,69.507,33.146,46.578,16.03a1.645,1.645,0,0,1-.179-2.482L48.749,11.2a3.679,3.679,0,0,1,4.01-.8L80.68,21.972,92.252,49.893a3.679,3.679,0,0,1-.8,4.01L89.1,56.254A1.645,1.645,0,0,1,86.622,56.075Z",
    transform: "translate(-41.214 -10.12)",
    fill: "#ccdfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122932",
    "data-name": "Path 122932",
    d: "M18.618,319.345,10.747,308.88.282,301.009a.706.706,0,0,1-.075-1.063l1.207-1.207a2.762,2.762,0,0,1,3.092-.563l11.664,5.28,5.28,11.664a2.762,2.762,0,0,1-.563,3.092l-1.207,1.207A.706.706,0,0,1,18.618,319.345Z",
    transform: "translate(0 -268.454)",
    fill: "#ccdfed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41280",
    "data-name": "Group 41280",
    transform: "translate(0 4.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122933",
    "data-name": "Path 122933",
    d: "M21.451,327.995,19.642,324h0l-1.126,1.126a2.281,2.281,0,0,1-3.436-.242l-3.2-4.26-.01.01L.754,312.273h0l-.547.547a.706.706,0,0,0,.075,1.063l10.465,7.871,7.871,10.465a.706.706,0,0,0,1.063.075l1.207-1.207A2.762,2.762,0,0,0,21.451,327.995Z",
    transform: "translate(0 -284.579)",
    fill: "#bad5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122934",
    "data-name": "Path 122934",
    d: "M92.205,81.337c.047-.1.092-.206.129-.312a3.724,3.724,0,0,0-.068-2.642l-1.682-4.059-.107-.258a3.677,3.677,0,0,1-1.049,2.145l-2.351,2.351a1.645,1.645,0,0,1-2.482-.179L71,60.163l-24.4-18.3-.178.178a1.649,1.649,0,0,0,.179,2.482l14.9,11.12,8.032,6,6,8.032,11.12,14.9a1.649,1.649,0,0,0,2.482.179l2.351-2.351A3.671,3.671,0,0,0,92.205,81.337Z",
    transform: "translate(-41.229 -41.862)",
    fill: "#bad5e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122935",
    "data-name": "Path 122935",
    d: "M78.432,57.182h0a2.106,2.106,0,0,1-2.808-2.808h0A49.213,49.213,0,0,1,82.84,43.348l19.851-22.919a17.363,17.363,0,0,1,11.539-5.923l1.217-.112a2.726,2.726,0,0,1,2.963,2.963l-.112,1.217a17.364,17.364,0,0,1-5.923,11.539L89.458,49.966A49.21,49.21,0,0,1,78.432,57.182Z",
    transform: "translate(-67.688 -13.137)",
    fill: "#61aff6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122936",
    "data-name": "Path 122936",
    d: "M123.868,18.575l.112-1.217a2.726,2.726,0,0,0-2.963-2.963l-1.217.112-.048,0A17.363,17.363,0,0,1,113.833,26L81.614,56.78a2.069,2.069,0,0,0,2.386.4h0a49.212,49.212,0,0,0,11.026-7.216l22.919-19.851A17.363,17.363,0,0,0,123.868,18.575Z",
    transform: "translate(-73.256 -13.137)",
    fill: "#399aea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122937",
    "data-name": "Path 122937",
    d: "M393.43,56.235A.784.784,0,0,0,393.3,57.8a4.007,4.007,0,0,1,3.96,3.96.784.784,0,1,0,1.563-.134A5.57,5.57,0,0,0,393.43,56.235Z",
    transform: "translate(-352.373 -50.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122938",
    "data-name": "Path 122938",
    d: "M432.054,77.312a.784.784,0,0,0,.715-.848,5.925,5.925,0,0,0-1.57-3.7q-.363.759-.8,1.481a4.621,4.621,0,0,1,.8,2.352.785.785,0,0,0,.848.715Z",
    transform: "translate(-386.322 -65.539)",
    fill: "#ccdfed"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.0b06d118402c51dedee8374055ef4841.svg";
export { ForwardRef as ReactComponent };